var exports = {
  "w": "xa15a2ab7--8d7aa8--logo",
  "D": "xa15a2ab7--8d7aa8--title",
};

module.exports = exports;
